import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/kontaktiere-uns/Kontakt.js");
